module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_Projects_ReadAll')) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "projects-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getProjectData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Projects_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-create-button",
      "disabled": _vm.clientList.length < 1
    },
    on: {
      "click": function($event) {
        (_vm.selectedProject = -1),
        (_vm.editProjectDialogModeAdd = true),
        (_vm.showEditProjectDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Projects_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-edit-button",
      "disabled": _vm.selectedProject == -1
    },
    on: {
      "click": function($event) {
        (_vm.editProjectDialogModeAdd = false), (_vm.showEditProjectDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Projects_Delete')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-delete-button",
      "disabled": _vm.selectedProject == -1
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteProjectDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0003) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Scenarios_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-scenario-button",
      "disabled": _vm.selectedProject == -1
    },
    on: {
      "click": function($event) {
        _vm.showEditScenarioDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("wallpaper")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0028) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_ProjectWaves_ReadAll') &&
    _vm.globals.isAccessAllowed('LoopOp_ProjectWaves_Read')
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-wave-button",
      "disabled": _vm.selectedProject == -1
    },
    on: {
      "click": function($event) {
        _vm.showEditWaveDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("schedule")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0029) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.P0004
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P0005))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P0006))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P0007))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "projectsTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "projectsTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P0032))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('projectId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0008) + "\n                "), (_vm.sortField == 'projectId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'projectId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('projectName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0009) + "\n                "), (_vm.sortField == 'projectName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'projectName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('clientName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0030) + "\n                "), (_vm.sortField == 'clientName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'clientName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('importerName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0031) + "\n                "), (_vm.sortField == 'importerName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'importerName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectActiveLocationsCount')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0010) + "\n                "), (
    _vm.sortField == 'ProjectActiveLocationsCount' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ProjectActiveLocationsCount' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectTotalLocationsCount')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0011) + "\n                "), (
    _vm.sortField == 'ProjectTotalLocationsCount' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ProjectTotalLocationsCount' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectSurveysCount')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0012) + "\n                "), (
    _vm.sortField == 'ProjectSurveysCount' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ProjectSurveysCount' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectSince')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0014) + "\n                "), (_vm.sortField == 'ProjectSince' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ProjectSince' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectCreatedBy')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.P0015) + "\n                "), (_vm.sortField == 'ProjectCreatedBy' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ProjectCreatedBy' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectId),
      expression: "filterStrings.ProjectId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectName),
      expression: "filterStrings.ProjectName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ClientName),
      expression: "filterStrings.ClientName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ClientName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ClientName", $event.target.value)
      }
    }
  })])]) : _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ImporterName),
      expression: "filterStrings.ImporterName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ImporterName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ImporterName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectActiveLocationsCount),
      expression: "filterStrings.ProjectActiveLocationsCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectActiveLocationsCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectActiveLocationsCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectTotalLocationsCount),
      expression: "filterStrings.ProjectTotalLocationsCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectTotalLocationsCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectTotalLocationsCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectSurveysCount),
      expression: "filterStrings.ProjectSurveysCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectSurveysCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectSurveysCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectSince),
      expression: "filterStrings.ProjectSince"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectSince)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectCreatedBy),
      expression: "filterStrings.ProjectCreatedBy"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectCreatedBy)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectCreatedBy", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.projectData), function(project) {
    return _c('tr', {
      key: project.ProjectId,
      class: {
        info: project.ProjectId == _vm.selectedProject
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedProject = project.ProjectId),
          (_vm.clientOfSelectedProject = project.ClientId)
        },
        "dblclick": function($event) {
          (_vm.editProjectDialogModeAdd = false),
          (_vm.showEditProjectDialog = true)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(project.ProjectId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(project.ProjectName))]), _vm._v(" "), (
      !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("\n              " + _vm._s(project.ClientName) + "\n            ")]) : _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(project.ImporterName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n              " + _vm._s(project.ProjectActiveLocationsCount) + "\n            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n              " + _vm._s(project.ProjectTotalLocationsCount) + "\n            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(project.ProjectSurveysCount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(project.ProjectSince))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(project.ProjectCreatedBy))])])
  }), 0)])])]), _vm._v(" "), _c('ProjectManagementEditModal', {
    attrs: {
      "selectedProject": _vm.selectedProject,
      "clientList": _vm.clientList,
      "surveyList": _vm.surveyList,
      "showDialog": _vm.showEditProjectDialog,
      "dialogModeAdd": _vm.editProjectDialogModeAdd
    },
    on: {
      "dialogClosed": _vm.onEditProjectDialogClosed,
      "dialogDataSaved": _vm.onEditProjectDialogDataSaved
    }
  }), _vm._v(" "), _c('ScenarioEditModal', {
    attrs: {
      "showDialog": _vm.showEditScenarioDialog,
      "selectedProjectData": _vm.selectedProjectData,
      "clientList": _vm.clientList,
      "selectedClientFromProject": _vm.clientOfSelectedProject
    },
    on: {
      "dialogClosed": _vm.onEditScenarioDialogClosed
    }
  }), _vm._v(" "), _c('WaveEditModal', {
    attrs: {
      "showDialog": _vm.showEditWaveDialog,
      "selectedClient": _vm.clientOfSelectedProject,
      "selectedProjectData": _vm.selectedProjectData
    },
    on: {
      "dialogClosed": _vm.onEditWaveDialogClosed
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "deleteProjectDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.P0019))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.P0020))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.P0021))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteProjectDialogData.ProjectId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.P0022))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteProjectDialogData.ProjectName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.P0023))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteProjectDialogData.ProjectSince))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "deleteFalse",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.P0024) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "id": "project-management-delete-true-dialog-button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteProjectData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.P0025) + "\n          ")])])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a2e1f37","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectManagement/ProjectManagement.vue
// module id = 1678
// module chunks = 1